<main class="login-container">
    <div class="login-card">
        <div class="login__icon">
            <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-vertical"></app-icon>
        </div>
        <div *ngIf="auth0Error" class="error-text">
            {{ auth0Error }}
        </div>

        <p class="login-text">
            Please log in to access the application
        </p>

        <app-button (onClick)="loginWithAuth0($event)" text="LOGIN WITH AUTH0"></app-button>
    </div>
</main>